import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
    tag: { background: '#F0F2F6', borderRadius: 4, '& .MuiChip-deleteIcon': { color: 'rgba(17, 30, 20, 0.4)' } },
    root: {
        '& .MuiAutocomplete-input': { flexGrow: 0 },
        '& .MuiAutocomplete-inputRoot': {
            flexDirection: 'row-reverse',
            justifyContent: 'flex-end',
        },
    },
    error: { width: '100%', padding: 0, margin: 0, border: '2px solid red', borderRadius: 4 },
}));

const AfitdAutocomplete = props => {
    const classes = useStyles();
    const { onBlur, onFocus, value, placeholder, options, onChange, id, dp, disabled, chipProps, error, ...otherProps } = props;
    return (
        <Autocomplete
            ChipProps={
                chipProps || {
                    deleteIcon: <CloseIcon />,
                    avatar: dp && <img alt="dp" src={dp} style={{ borderRadius: 50 }} />,
                }
            }
            id={id}
            disableClearable={!value}
            fullWidth
            classes={{ tag: classes.tag, root: error && classes.error }}
            disabled={disabled}
            value={value}
            options={options}
            getOptionLabel={option => option}
            renderInput={params => <TextField onBlur={onBlur} onFocus={onFocus} {...params} variant="outlined" color="secondary" placeholder={placeholder} />}
            onChange={onChange}
            {...otherProps}
        />
    );
};

export default AfitdAutocomplete;
